import TopNav from "./components/TopNav";
import Ticker from "./components/Ticker";
import HeroHeadline from "./components/HeroHeadline";
import GuideCards from "./components/GuideCards";
import HotRank from "./components/HotRank";
import Catalog from "./components/Catalog";
import TimelineSection from "./components/TimelineSection";
import CardFlow from "./components/CardFlow";
import CommentsSection from "./components/CommentsSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopNav />
      <Ticker />
      <main className="w-full">
        <HeroHeadline />
        <GuideCards />
        <HotRank />
        <Catalog />
        <TimelineSection />
        <CardFlow />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}